import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Container, Typography, Button } from '@mui/material';
import PublicNavbar from '../components/public/PublicNavbar';
import Navbar from '../components/Navbar';
import authService from '../services/auth';
import { BEGINNER_TERMS } from '../content/beginnerTerms';
import { LEARN_CATEGORIES } from '../content/learnCenter';

const LearnPage: React.FC = () => {
  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'background.default' }}>
      {authService.getToken() ? <Navbar /> : <PublicNavbar />}
      <Container maxWidth="md" sx={{ py: 4 }} component="main">
        <Typography variant="h3" component="h1" sx={{ fontWeight: 800, mb: 1 }}>
          Learning Center
        </Typography>
        <Typography color="text.secondary" sx={{ mb: 4 }}>
          Explanations DealSkout already uses while you analyze a flip or resale. This is not rental
          underwriting, and it is not a recommendation to purchase.
        </Typography>
        <Box sx={{ display: 'grid', gap: 4 }}>
          {LEARN_CATEGORIES.map((category) => (
            <Box key={category.id} component="section" aria-labelledby={`learn-${category.id}`}>
              <Typography id={`learn-${category.id}`} variant="h5" component="h2" sx={{ fontWeight: 800, mb: 1 }}>
                {category.title}
              </Typography>
              <Typography sx={{ mb: 2 }}>{category.intro}</Typography>
              <Box sx={{ display: 'grid', gap: 1.5 }}>
                {category.termIds.map((id) => {
                  const item = BEGINNER_TERMS[id];
                  return (
                    <Box
                      key={`${category.id}-${id}`}
                      sx={{ p: 2, borderRadius: 2, border: '1px solid', borderColor: 'divider', bgcolor: 'background.paper' }}
                    >
                      <Typography variant="subtitle1" sx={{ fontWeight: 800 }}>
                        {item.label}
                      </Typography>
                      <Typography variant="body2" sx={{ mt: 0.5 }}>
                        {item.short}
                      </Typography>
                      <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                        {item.detail}
                      </Typography>
                    </Box>
                  );
                })}
              </Box>
            </Box>
          ))}
        </Box>
        <Button component={RouterLink} to="/signup" variant="contained" sx={{ mt: 4 }}>
          Start free
        </Button>
      </Container>
    </Box>
  );
};

export default LearnPage;
